import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomWorkWithUsComponent} from './custom-work-with-us.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from "@spartacus/core";
import {FormErrorsModule} from "@spartacus/storefront";
import {ReactiveFormsModule} from "@angular/forms";
import {CustomIconsModule} from "../../../icons/custom-icons.module";
import {CustomFileUploaderModule} from "../../../forms/file-uploader/custom-file-uploader.module";
import {RouterModule} from "@angular/router";
import {NgSelectModule} from "@ng-select/ng-select";


@NgModule({
  declarations: [CustomWorkWithUsComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        WorkWithUsFormComponent: {
          component: CustomWorkWithUsComponent,
        },
      },
    } as CmsConfig),
    I18nModule,
    FormErrorsModule,
    ReactiveFormsModule,
    CustomIconsModule,
    CustomFileUploaderModule,
    UrlModule,
    RouterModule,
    NgSelectModule,
  ]
})
export class CustomWorkWithUsModule { }
